import React from "react";
import { useNavigate } from "react-router-dom";
import { secondaryButtonCls } from "../../../components/ui-components/buttonStyles";

// InvestigateButton — reusable inbound entry point into the Investigation Workspace.
// Navigates to the investigations list carrying a pre-built Seed via router state so
// NewInvestigationModal opens pre-filled and ready to preview. Any surface (Financial
// Control, Enforcement, Forecast) can mount this with a Seed that matches what it's
// already showing.
export default function InvestigateButton({ seed, label = "Investigate", className }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={className || secondaryButtonCls}
      onClick={() => navigate("/investigations", { state: { newSeed: seed } })}
    >
      {label}
    </button>
  );
}
